/**
 * Converts a camelCase or PascalCase string to snake_case.
 *
 * It inserts an underscore between a lowercase/number character
 * and an uppercase character, then lowercases the entire string.
 *
 * @example
 * toSnakeCase('userName') // "user_name"
 * toSnakeCase('UserName') // "user_name"
 * toSnakeCase('version1Number') // "version1_number"
 *
 * @param value - The input string in camelCase or PascalCase format.
 * @returns The transformed string in snake_case.
 */
export const toSnakeCase = (value: string): string => {
  return value.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toLowerCase();
};

export default toSnakeCase;
